import React, { useContext} from 'react';
import PropTypes from 'prop-types';
import {
  ForgeIcon,
  ForgeToolbar,
  ForgeBadge,
  ForgeIconButton,
} from '@tylertech/forge-react';
import Tabs from './Tabs.js';
import ViewOnlyInlineMessage from '../ViewOnlyInlineMessage/ViewOnlyInlineMessage.js';
import HeaderButtons from './HeaderButtons.js';
import { Context } from '../../../store/Store.js';
import { REDUCER_ACTION_TYPES } from '../../../store/Reducer.js';
import { useUser } from '../../../contexts/userContext.js';
import './Title.scss';
import TitleInlineMessage from './TitleInlineMessage.js';

const Title = ({
  title,
  headerBadges,
  headerButtons,
  headerTabButtons,
  activeTab = 0,
  handleTabChange,
  showGoBackButton,
  handleGoBack,
  titleIcon='',
  titleIconClassName = 'title-icon-class',
  inlineMessage,
}) => {
  const { user } = useUser();
  const [, dispatch] = useContext(Context);

  return (
    <>
      <ForgeToolbar slot="body-header" className={'fixed-header'}>
        {showGoBackButton && (
          <ForgeIconButton
            slot="before-start"
            onClick={() => {
              dispatch(({ type: REDUCER_ACTION_TYPES.BACK_BUTTON_FIRED, payload: true }));
              handleGoBack();
            }}
            style={{ cursor: 'pointer', marginLeft: '12px' }}
            aria-label="Go Back"
          >
            <ForgeIcon
              external 
              externalType="all"
              name="arrow_back"
            />
          </ForgeIconButton>
        )}
        <h1 slot={'start'} className="reusable-scaffold-title">
          {title}
        </h1>
        {titleIcon && (
          <ForgeIcon
            external 
            externalType="all"
            name={titleIcon}
            className={titleIconClassName}
          />
        )}
        {headerBadges &&
          headerBadges.map((badge) => {
            return (
              <ForgeBadge
                key={badge.id}
                theme={badge.theme}
                style={{ marginLeft: '12px'}}
                className={'forge-typography--heading1'}
                slot={'start'}
              >
                {badge.text}
              </ForgeBadge>
            );
          })}
        <HeaderButtons headerButtons={headerButtons} />
        
      </ForgeToolbar>
      {headerTabButtons && (
        <Tabs
          headerTabButtons={headerTabButtons}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
        />
      )}
      {user?.isViewOnly ? <ViewOnlyInlineMessage headerTabButtons={headerTabButtons} /> : null}
      
      { inlineMessage &&  (<TitleInlineMessage inlineMessage={inlineMessage} isViewOnly = {user?.isViewOnly} withTabs = {Boolean(headerTabButtons?.length)}/>)}
    </>
  );
};

Title.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  headerBadges: PropTypes.array,
  headerButtons: PropTypes.array,
  headerTabButtons: PropTypes.array,
  activeTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  showGoBackButton: PropTypes.bool,
  handleGoBack: PropTypes.func,
  titleIcon: PropTypes.string,
  titleIconClassName: PropTypes.string,
  inlineMessage: PropTypes.string,
};

export default Title;
